import { useReveal } from '../hooks/useReveal';
import MaterialIcon from './MaterialIcon';
import IdeCodePanel from './code/IdeCodePanel';

export default function Mission() {
  const [ref, visible] = useReveal();

  return (
    <section id="mission" className="ca-section" ref={ref} data-analytics-section="mission">
      <div className="ca-container">
        <div className={`ca-mission ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}>
          <div className="ca-mission__block">
            <div className="ca-mission__icon">
              <MaterialIcon name="flag" variant="pulse" />
            </div>
            <p className="ca-eyebrow">Mission</p>
            <p className="ca-mission__text">
              To build transformative software that bridges the gap between challenge and
              possibility—crafted with purpose, powered by passion, and built for progress.
            </p>
          </div>
          <div className="ca-mission__block ca-mission__block--vision">
            <div className="ca-mission__icon">
              <MaterialIcon name="auto_awesome" variant="glow" />
            </div>
            <p className="ca-eyebrow">Vision</p>
            <p className="ca-mission__text">
              To become the arc that connects people and businesses to their next breakthrough—by
              creating software that is intuitive, impactful, and deeply human.
            </p>
          </div>
        </div>
        <p className={`ca-tagline ca-reveal ${visible ? 'ca-reveal--visible' : ''}`} style={{ transitionDelay: '120ms' }}>
          Where passion meets progress.
        </p>

        <IdeCodePanel
          variant="observe"
          caption="Structured logs, retries, and cache coherence—we debug with signals so incidents shrink, not spread."
          flip
        />
      </div>
    </section>
  );
}
